<tds-icon name="info" [matTooltip]="text" [matTooltipPosition]="position" matTooltipShowDelay="500"
          matTooltipHideDelay="500" size="xs" class="label-icon help" data-testid="tooltip"></tds-icon>
